import { Injectable } from '@angular/core';
import { ChannelGroupApiService } from './channel-group-api.service';
import { Observable } from 'rxjs';
import { ChannelGroup } from 'ops/common/models/channel-group';

@Injectable({ providedIn: 'root' })
export class ChannelGroupService {
    constructor(private groupApi: ChannelGroupApiService) {}

    getGroups(): Observable<ChannelGroup[]> {
        return this.groupApi.getGroups();
    }
}
